import React, { FC } from "react";
import styled from "styled-components";
import SeeMore, { SeeMoreButton } from "components/front/motion/SeeMore";

export const SectionContent: FC<{
  content: string;
  usesSeeMore?: boolean;
}> = ({ content, usesSeeMore }) => {
  return usesSeeMore ? (
    <SeeMore threshold={380} noClose moreText="もっと見る▼" Button={SeeMoreButton}>
      <Content dangerouslySetInnerHTML={{ __html: content.replace(/\n/g, "<br />") }} />
    </SeeMore>
  ) : (
    <Content dangerouslySetInnerHTML={{ __html: content.replace(/\n/g, "<br />") }} />
  );
};

const Content = styled.div`
  width: 100%;
  color: #fff;
  @media screen and (max-width: 960px) {
    font-size: 14px;
    line-height: 1.428em;
  }
  @media screen and (min-width: 961px) and (max-width: 1280px) {
    font-size: 14px;
    line-height: 1.65em;
  }
  @media screen and (min-width: 1281px) {
    font-size: 16px;
    line-height: 1.65em;
  }

  & .responsive_movie {
    width: 100%;
    aspect-ratio: 16/9;
  }

  & img {
    width: 100%;
  }
`;
